<template>
  <div class="ak-login-forms">
    <div class="nav">
      <div class="ak-nav-title">
        网管系统
      </div>
    </div>
    <div class="ak-login-form" @keydown="enterLogin($event)">
      <div
        style="text-align:center; font-size:30px; font-weight: bold; font-family:times color:#191a32; padding-bottom: 38px;"
      >
        <b>登录</b>
      </div>

      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="username">
          <input
            key="loginname"
            class="my-input"
            type="text"
            v-model="form.username"
            placeholder="用户名"
          />
        </el-form-item>

        <el-form-item prop="password">
          <input
            key="loginpwd"
            class="my-input"
            type="password"
            v-model="form.password"
            placeholder="密码"
          />
        </el-form-item>
        <br />
        <div class="my-btn" @click="login">登录</div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    login() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false;
        }
        this.$http.post("login/", this.form, data => {
          localStorage.setItem("token", data.data.token);
          localStorage.setItem("id", data.data.id);
          localStorage.setItem("username", data.data.username);
          localStorage.setItem("is_admin", data.data.is_admin);
          this.$http.get("account/" + data.data.id + "/", {}, data => {
            localStorage.setItem("department", data.data.department);
            localStorage.setItem("email", data.data.email);
            localStorage.setItem("mobile", data.data.mobile);
          });
          const redirect = this.$route.query.redirect;
          this.$router.push(typeof redirect === "string" && redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : "/");
        });
      });
    },
    enterLogin(ev) {
      if (ev.keyCode === 13) this.login();
    }
  }
};
</script>
<style lang="less">
.ak-login-forms {
  position: relative;
  margin: 0 auto;
}
.ak-login-form {
  width: 372px;
  height: 400px;
  border: solid 1px gray;
  border-radius: 10px;
  margin: 100px 650px;
  padding: 36px 66px 50px 66px;
  background-color: white;
}
.ak-login-form2 {
  margin-top: 80px;
  width: 372px;
  height: 452px;
  border: solid 1px gray;
  border-radius: 10px;

  padding: 36px 66px 50px 66px;
  background-color: white;
}
.my-input {
  width: 100%;
  height: 54px;
  outline: none;
  border: 1px solid #dadada;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 16px;
  box-sizing: border-box;
}
.nav {
  background-color: #545c64;
  height: 100%;
  .ak-nav-title {
    display: inline-block;
    cursor: pointer;
    color: white;
    text-align: left;
    line-height: 74px;
    margin-left: 55px;
    font-size: 30px;
  }
}
.my-btn {
  height: 54px;
  color: #fff;
  background-color: #909399;
  font-size: 16px;
  line-height: 54px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
}
.my-btn:hover {
  background-color: #606266;
}
input::-webkit-input-placeholder {
  color: #909090;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #909090;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #909090;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #909090;
}
</style>
